import styled from "styled-components";
import { css } from "styled-components";

export const FooterStyled = styled.footer`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 100%;
  height: 50px;
  gap: 5px;
  font-size: 16px;
  border-top: 2px solid
    ${(props) =>
      props.darkmode ? " rgba(64, 64, 64, 0.77)" : "rgba(191, 191, 191, 0.78)"};
  ${({ relative }) =>
    relative
      ? css`
          position: absolute;
          bottom: 0px;
          z-index: 2;
        `
      : css`
          position: relative;
        `}

  ${({ background }) =>
    background
      ? css`
          background: var(--degrade);
        `
      : css`
          background: linear-gradient(
            0deg,
            rgba(255, 255, 255, 1) 46%,
            rgba(213, 213, 213, 1) 98%
          );
        `}

  background: ${(props) =>
    props.darkMode
      ? `linear-gradient(180deg,rgba(44, 79, 23, 1) 0%, rgba(74, 120, 47, 1) 100%)`
      : "var(--degrade)"};

  /* background: transparent; */
  color: rgb(46, 46, 46);
  color: ${(props) =>
    props.darkmode ? " rgb(191, 191, 191)" : "rgb(46, 46, 46)"};

  span {
    color: ${(props) =>
      props.darkmode ? " rgb(191, 191, 191)" : "rgb(46, 46, 46)"};
    color: white;
    text-align: center;
  }

  ul {
    display: flex;
    gap: 8px;
    list-style: none;
    li {
      color: ${(props) =>
        props.darkmode ? " rgb(191, 191, 191)" : "rgb(46, 46, 46)"};
      color: white;
      cursor: pointer;
      a {
        text-decoration: none;
        text-decoration: none !important;
        color: ${(props) =>
          props.darkmode ? " rgb(191, 191, 191)" : "rgb(46, 46, 46)"};
        color: white;
      }
      a:hover {
        color: var(--cor-constraste);
      }
    }
  }

  .manual {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    font-size: 13px;
    position: absolute;
    left: 80px;
    bottom: 15px;
    cursor: pointer;
    color: ${(props) =>
      props.darkmode ? " rgb(191, 191, 191)" : "rgb(46, 46, 46)"};
    color: white;
    transition: 0.3s ease;

    .iconManual {
      font-size: 17px;
    }

    @media (max-width: 550px) {
      font-size: 0;
      left: 15px;
      .iconManual {
        font-size: 18px;
      }
    }
  }

  .manual:hover {
    color: rgb(255, 255, 255);
  }

  @media only screen and (max-width: 800px) and (orientation: portrait) {
    margin-top: 0px;
    gap: 5px;
    font-size: 12px;
    height: 60px;
    ul {
      gap: 3px;
      font-size: 15px;
    }
  }

  @media only screen and (max-width: 940px) and (orientation: landscape) {
    position: relative;
    margin-top: 2em;
    padding: 10px;
    bottom: 0px;
    z-index: 2;
  }
`;
